import { Slot } from '@/shared/lib'
import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
}

export const HostIntroField = ({
  placeholder,
  readOnly = false,
  disabled = false,
}: Props) => {
  return (
    <Form.Field name="hostIntro" readOnly={readOnly} disabled={disabled}>
      <Form.Label className="font-medium text-black">호스트 소개</Form.Label>
      <Form.Textarea
        className="h-32"
        useCount
        maxLength={30}
        readOnly={readOnly}
        placeholder={
          placeholder ||
          `게스트에게 보여지는 소개글입니다.\n소개글은 최대 30자까지 작성해 주세요.`
        }
      >
        <Slot name="message">
          <Form.Message />
        </Slot>
      </Form.Textarea>
    </Form.Field>
  )
}
